module.exports = __webpack_public_path__ + "static/media/movie2.c7b6e694.mp4";